import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant()',
    '[class.is-disabled]': 'disabled()',
  },
  templateUrl: './app-button.html',
  styles: `
    :host {
      display: block;
    }

    button {
      width: 100%;
      border: 0;
      border-radius: 0.75rem;
      min-height: 3.25rem;
      padding: 0.8rem 1.25rem;
      font: inherit;
      font-weight: 700;
      cursor: pointer;
      transition:
        transform 140ms ease,
        box-shadow 140ms ease,
        background 140ms ease;
    }

    button:focus-visible {
      outline: 3px solid color-mix(in srgb, var(--color-primary) 45%, white);
      outline-offset: 3px;
    }

    button:not(:disabled):active {
      transform: translateY(1px);
    }

    :host(.primary) button {
      color: white;
      background: linear-gradient(180deg, #278ba0, #166c80);
      box-shadow: inset 0 -0.2rem 0 rgba(0, 0, 0, 0.12), var(--shadow-soft);
    }

    :host(.secondary) button {
      color: var(--color-primary);
      background: #dff2f6;
      border: 2px solid #bee3ea;
    }

    :host(.ghost) button {
      color: var(--color-text-muted);
      background: #f4f4f4;
      font-weight: 600;
    }

    button:disabled {
      cursor: not-allowed;
      opacity: 0.55;
      box-shadow: none;
    }
  `,
})
export class AppButton {
  variant = input<'primary' | 'secondary' | 'ghost'>('primary');
  type = input<'button' | 'submit'>('button');
  disabled = input(false, { transform: booleanAttribute });
}
